import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Constants from '../../../../model/AppConfiguration';
import { AppBar, Typography, Button, withStyles } from 'material-ui';
import Tabs, { Tab } from 'material-ui/Tabs';
import TabStyles from './CalendarTabStyles';
import TabsStyles from './CalendarTabsStyles';
import CalendarDesktop from '../../../../components/flights/calendarDesktop/CalendarDesktop';
import FlightsScreenController from '../../FlightsScreenController';
import FlightSeats from '../../../../components/flights/flightSeats/FlightSeats';
import CalendarLegend from '../../../../components/flights/calendarLegend/CalendarLegend';
import CalendarHeader from '../../../../components/flights/calendarMobile/CalendarHeader';
import moment from 'moment';
import Dictionary from '../../../../model/Dictionary';
import PlaneIcon from '../../../../icons/PlaneIcon';
import ClassNames from 'classnames';
import ColorPalette from '../../../../components/styling/ColorPalette';
import '../../../routeTabs/RouteTabs.css';
import StyledComponent from '../../../../components/styling/StyledComponent';

function TabContainer (props) {
  return (
    <Typography
      component='div'
      style={{
        top: '60px',
        width: '100%',
        height: '100%',
        display: 'block',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      {props.children}
    </Typography>
  );
}

TabContainer.propTypes = { children: PropTypes.node.isRequired };

class CalendarDesktopTabs extends Component {
  generateTabName = (route, selectedTab, isRouteActive, isArrival) => {
    const { flights } = this.props;
    let departure = isArrival ? route.arrival.slice(0, 3) : route.departure.slice(0, 3);
    let arrival = isArrival ? route.departure.slice(0, 3) : route.arrival.slice(0, 3);
    let departureDate =
      flights[ 0 ] && flights[ 0 ].date ? flights[ 0 ].date : Dictionary.flights.selectDate;
    let arrivalDate =
      flights[ 1 ] && flights[ 1 ].date ? flights[ 1 ].date : Dictionary.flights.selectDate;
    let selectedDate = isArrival ? arrivalDate : departureDate;
    selectedDate = FlightsScreenController.formatDateLongMonthWithDay(selectedDate);

    return (
      <span className='tab-icon-text-wrapper'>
        <span className='route-name'>
          {departure}
          &nbsp;&nbsp;
          <PlaneIcon
            className={ClassNames({
              'plane-selected': isRouteActive,
              'plane-default': !isRouteActive,
            })}
          />&nbsp;
          {arrival}
          <div className='route-date'>{selectedDate}</div>
        </span>
      </span>
    );
  };

  render () {
    const {
      selectedRoute,
      selectedTrip,
      flights,
      selectDate,
      handleTabChange,
      selectedTab,
      departureFlight,
      arrivalFlight,
      handleClose,
      classes,
    } = this.props;

    let tab = selectedTrip && selectedTrip.id === Constants.flights.roundTrip ? selectedTab : 0;
    let currentlyActiveRoute = selectedRoute ? parseInt(selectedRoute.id, 10) - 1 : '';
    let isRouteActive = currentlyActiveRoute === tab;
    let tab1 = this.generateTabName(selectedRoute, tab, isRouteActive);
    let tab2 = this.generateTabName(selectedRoute, tab, !isRouteActive, true);
    let isRoundTrip = selectedTrip && selectedTrip.id === Constants.flights.roundTrip;
    const StyledTabs = StyledComponent(Tabs)(TabsStyles);

    return (
      <div>
        <CalendarHeader selectedTrip={selectedTrip} handleClose={handleClose} />
        <AppBar
          position='static'
          style={{
            backgroundColor: ColorPalette.navigationBgBlue,
            borderRadius: 0,
            width: '100%',
            boxShadow: 'none',
          }}
        >
          <StyledTabs
            value={tab}
            onChange={handleTabChange}
            indicatorColor='none'
            textColor='primary'
            centered
          >
            <Tab
              icon={tab1}
              label={tab1.selectedDate}
              classes={classes}
              style={{ minWidth: isRoundTrip ? 'inherit' : 'calc(100% - 5px)' }}
            />
            {isRoundTrip ? <Tab icon={tab2} label={tab2.selectedDate} classes={classes} /> : null}
          </StyledTabs>
        </AppBar>
        {flights.map((flight, index) => {
          if (
            index !== selectedTab ||
            (selectedTrip && selectedTrip.id === Constants.flights.oneWay && index > 0)
          ) {
            return null;
          }
          return (
            <TabContainer key={`calendar-deskto-tab-${flight.id}-${index}`}>
              <CalendarDesktop
                routeId={`${tab + 1}`}
                flightId={flight.id}
                selectDate={selectDate}
                selectedDate={flight.date}
                prefix={index === 0 ? 'departure' : 'arrival'}
                minDate={
                  flights[ index - 1 ] ?
                    flights[ index - 1 ].date :
                    moment(new Date()).format(Constants.DATE_FORMAT)
                }
                maxDate={
                  selectedTrip && selectedTrip.id === Constants.flights.oneWay ?
                    null :
                    flights[ index + 1 ] ? flights[ index + 1 ].date : null
                }
              />
              {/* {departureFlight && index === 0 ? (
                <FlightSeats flightId={departureFlight.id} seats={departureFlight.text} />
              ) : null}

              {arrivalFlight && index === 1 ? (
                <FlightSeats flightId={arrivalFlight.id} seats={arrivalFlight.text} />
              ) : null} */}
              <CalendarLegend />
            </TabContainer>
          );
        })}
        <div className='calendar-dialog-footer'>
          <Button
            variant='raised'
            fullWidth
            color='primary'
            onClick={handleClose}
            className={classes.button}
          >
            Done
          </Button>
        </div>
      </div>
    );
  }
}

CalendarDesktopTabs.propTypes = {
  selectedRoute: PropTypes.object,
  selectedTrip: PropTypes.object,
  departureFlight: PropTypes.object,
  arrivalFlight: PropTypes.object,
  handleClose: PropTypes.func,
  selectDate: PropTypes.func,
  flights: PropTypes.arrayOf(PropTypes.object),
  selectedTab: PropTypes.number,
  handleTabChange: PropTypes.func,
  classes: PropTypes.object,
};

export default withStyles(TabStyles)(CalendarDesktopTabs);



// WEBPACK FOOTER //
// ./src/containers/flights/desktop/calendar/CalendarDesktopTabs.js